import apiClient from '../api/apiClient';

function unwrap(res) {
  const body = res?.data;
  if (body && typeof body === 'object' && 'data' in body) return body.data;
  return body;
}

const BASE = '/api/v1/admin/reports/pre-ipo';

function buildParams({ startDate, endDate, scopeUserId = 'all' }) {
  return {
    start_date: startDate,
    end_date: endDate,
    scope_user_id: scopeUserId,
  };
}

export function getAdminPreIpoOverview(params) {
  return apiClient.get(`${BASE}/overview`, { params: buildParams(params) }).then(unwrap);
}

export function getAdminPreIpoPipeline(params) {
  return apiClient.get(`${BASE}/pipeline`, { params: buildParams(params) }).then(unwrap);
}

export function getAdminPreIpoProductMix(params) {
  return apiClient.get(`${BASE}/product-mix`, { params: buildParams(params) }).then(unwrap);
}

export function getAdminPreIpoPartners(params) {
  return apiClient.get(`${BASE}/partners`, { params: buildParams(params) }).then(unwrap);
}

const DEAL_SHEET_EXPORT_TIMEOUT_MS = 120000;
const DEAL_SHEET_DOWNLOAD_PATH = '/api/v1/admin/orders/deal-sheets/download';

export function downloadAdminPreIpoDealSheet(params) {
  return apiClient.post(
    DEAL_SHEET_DOWNLOAD_PATH,
    {
      start_date: params.startDate,
      end_date: params.endDate,
    },
    {
      responseType: 'blob',
      timeout: DEAL_SHEET_EXPORT_TIMEOUT_MS,
    },
  );
}
